import { config } from "config";
import { authController } from "contorller/auth/controller";
import { GSInfo } from "contorller/simulations/types";
import { DateTime } from "luxon";
import DownloadWorker from "../../worker_test.js?worker";
import { db, FundHistory } from "./db";

const MIN_REFRESH_HOURS_INTERVAL = 1;
const LOG_LEVEL = false;

const worker: Worker = new DownloadWorker();

export async function downloadFund(id: string, gsInfo?: GSInfo) {
  let auther = authController().getAuther();
  let headers = await auther.getHeaderToken();

  const baseUrl = config().URL;
  const message = {
    headers,
    baseUrl,
    fundId: id,
    gsInfo,
  };

  worker.postMessage(message);
}

export async function getFundData(
  id: string,
  gsInfo?: GSInfo,
  proxy: boolean = false,
): Promise<FundHistory> {
  const prefix = `[FundHistory-${makeDBFundId(id,gsInfo)}]`; 
  if (LOG_LEVEL) console.log(`${prefix} Get data`);

  const fundHistory = await db.histories.get(makeDBFundId(id,gsInfo));
  if (fundHistory != null) {
    if (LOG_LEVEL) console.log(`${prefix} Found in storage...`);

    const age = Math.abs(
      DateTime.fromSeconds(fundHistory.lastUpdate).diffNow("hours").hours
    );
    const shouldRefreshData = age > MIN_REFRESH_HOURS_INTERVAL;
    if (shouldRefreshData) {
      if (LOG_LEVEL) console.log(`${prefix} Refreshing data...`);
      downloadFund(id,gsInfo);
    } else {
      if (LOG_LEVEL)
        console.log(
          `${prefix} Not refreshing because the cached version age is ${age}`
        );
    }

    return {...fundHistory, fundId: getFundIdFromDBFundId(fundHistory.fundId)};
  } else {
    if (LOG_LEVEL)
      console.log(`${prefix} Not found in storage, waiting to download it`);
  }

  return new Promise((resolve) => {
    worker.addEventListener("message", (ev: MessageEvent<FundHistory>) => {
      if (ev.data.fundId === id) {
        resolve(ev.data);
      }
    });
    downloadFund(id,gsInfo);
    return null;
  });
}

export async function getCompareFundData(
  id: string,
  gsInfo?: GSInfo,
  proxy: boolean = false,
): Promise<{fundHistory: FundHistory, gsInfo?: GSInfo}> {
  const prefix = `[FundHistory-${makeDBFundId(id,gsInfo)}]`; 
  if (LOG_LEVEL) console.log(`${prefix} Get data`);

  const fundHistory = await db.histories.get(makeDBFundId(id,gsInfo));
  if (fundHistory != null) {
    if (LOG_LEVEL) console.log(`${prefix} Found in storage...`);

    const age = Math.abs(
      DateTime.fromSeconds(fundHistory.lastUpdate).diffNow("hours").hours
    );
    const shouldRefreshData = age > MIN_REFRESH_HOURS_INTERVAL;
    if (shouldRefreshData) {
      if (LOG_LEVEL) console.log(`${prefix} Refreshing data...`);
      downloadFund(id,gsInfo);
    } else {
      if (LOG_LEVEL)
        console.log(
          `${prefix} Not refreshing because the cached version age is ${age}`
        );
    }

    return {fundHistory:{...fundHistory, fundId: getFundIdFromDBFundId(fundHistory.fundId)},gsInfo};
  } else {
    if (LOG_LEVEL)
      console.log(`${prefix} Not found in storage, waiting to download it`);
  }

  return new Promise((resolve) => {
    worker.addEventListener("message", (ev: MessageEvent<FundHistory>) => {
      if (ev.data.fundId === id) {
        resolve({fundHistory: ev.data, gsInfo});
      }
    });
    downloadFund(id,gsInfo);
    return null;
  });
}

export function makeDBFundId(fundId: string, gsInfo?: GSInfo): string{
  if(gsInfo){
    return `${fundId}#|#${(gsInfo.retrocessione ?? 1.0).toString()}#|#${(gsInfo.floor ?? 0.0).toString()}`
  }
  return fundId;
}

export function getFundIdFromDBFundId(DBFundId: string): string{
  return DBFundId.split('#|#')[0];
}